import builder from '../builder';
import Lock1 from '../../streamline-icons/bold/lock-1.svg';

export default builder('IconLock1Bold', Lock1);
